"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const types_1 = require("../types");
const getReportsApiDefinition = ({ env, region, }) => {
    const key = region
        ? `${env.toLowerCase()}.${region.toLowerCase()}`
        : env.toLowerCase();
    return (0, lodash_1.get)(REPORTS_API_DEFINITIONS, key);
};
const REPORTS_API_DEFINITIONS = {
    [types_1.ApiEnv.QA]: {
        [types_1.Region.US]: {
            url: 'https://developer-stg.api.autodesk.com/reports-qa/v2',
        },
    },
    [types_1.ApiEnv.STG]: {
        [types_1.Region.US]: {
            url: 'https://developer-stg.api.autodesk.com/reports/v2',
        },
        [types_1.Region.EMEA]: {
            url: 'https://developer-stg.api.autodesk.com/reports/v2',
        },
        [types_1.Region.APAC]: {
            url: 'https://developer-stg.api.autodesk.com/reports/v2',
        },
        [types_1.Region.AUS]: {
            url: 'https://developer-stg.api.autodesk.com/reports/v2',
        },
        [types_1.Region.FEDRAMP]: {
            url: 'https://api-stg.afg.us.autodesk.com/reports/v2',
        },
    },
    [types_1.ApiEnv.PROD]: {
        [types_1.Region.US]: {
            url: 'https://developer.api.autodesk.com/reports/v2',
        },
        [types_1.Region.EMEA]: {
            url: 'https://developer.api.autodesk.com/reports/v2',
        },
        [types_1.Region.APAC]: {
            url: 'https://developer.api.autodesk.com/reports/v2',
        },
        [types_1.Region.AUS]: {
            url: 'https://developer.api.autodesk.com/reports/v2',
        },
        [types_1.Region.FEDRAMP]: {
            url: 'https://api.afg.us.autodesk.com/reports/v2',
        },
    },
    [types_1.ApiEnv.LOCAL]: {
        url: 'http://localhost:3000',
    },
};
exports.default = getReportsApiDefinition;
